// DashboardLayout - Layout route avec sidebar shadcn/ui
// Utilise comme layout route dans App.tsx pour les pages dashboard et admin

import { Outlet } from 'react-router-dom'
import AppSidebar from './AppSidebar'
import { SidebarProvider, SidebarInset } from '../ui/sidebar'
import { NotificationsProvider } from '../../contexts/NotificationsContext'

export default function DashboardLayout() {
  return (
    <NotificationsProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <main className="flex-1 p-6">
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
    </NotificationsProvider>
  )
}
